import React, { useMemo } from "react";
import { useRecurringTransactions } from "@/lib/hooks/api/quickbooks/recurring-transactions";
import { getEntityTableConfig } from "@/lib/entity-registry";
import { SimpleTable } from "@/components/shared/UniversalCRMTable/SimpleTable";
import { useRecurringTransactionHooks } from "@/lib/hooks/api/quickbooks/recurring-transactions";
import { useRoleCheck } from "@/lib/hooks/auth/useRoleCheck";
import { ColumnManagerProvider } from "@/lib/column-manager";
import { createColumnsFromConfig } from "@/lib/utils/columnFactory";
import { FilterContextProvider } from "@/contexts/FilterContext";
import type { RecurringTransaction } from "@/lib/types/recurring-transactions";

const RECURRING_TRANSACTIONS_CONFIG =
  getEntityTableConfig<RecurringTransaction>("recurring_transactions");

export function ContactRecurringTransactionsTab({ customerId }: { customerId: string }) {
  const { isAdmin } = useRoleCheck();
  const hooks = useRecurringTransactionHooks() as any;
  const { data, loading, error } = useRecurringTransactions({ customerId });

  const defaultColumns = useMemo(
    () => createColumnsFromConfig(RECURRING_TRANSACTIONS_CONFIG as any),
    []
  );

  if (!isAdmin) {
    return (
      <div className="flex items-center justify-center py-12">
        <div className="text-center">
          <h3 className="text-lg font-semibold text-card-foreground mb-2">Access Restricted</h3>
          <p className="text-gray-600 dark:text-gray-400">You need admin privileges to view recurring transactions.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <div>
        <h3 className="text-lg font-semibold text-card-foreground">Recurring Transactions</h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
          Manage recurring transactions that sync to QuickBooks monthly.
        </p>
      </div>
      <FilterContextProvider
        config={RECURRING_TRANSACTIONS_CONFIG as any}
        entityName="recurring-transactions"
      >
        <ColumnManagerProvider
          storageKey={`contact-${customerId}-recurring-transactions-column-preferences`}
          defaultColumns={defaultColumns}
        >
          <SimpleTable
            config={RECURRING_TRANSACTIONS_CONFIG}
            data={data}
            isLoading={loading}
            error={error}
            hooks={hooks}
            isDataPreFiltered={true}
          />
        </ColumnManagerProvider>
      </FilterContextProvider>
    </div>
  );
}
